export const GET_PIPE_RETURNS = 'GET_PIPE_RETURNS';
export const GET_PIPE_RETURNS_PAGE = 'GET_PIPE_RETURNS_PAGE';
export const PIPE_RETURN_REQUEST = 'PIPE_RETURN_REQUEST';
export const CREATE_PIPE_RETURN = 'CREATE_PIPE_RETURN';
export const UPDATE_PIPE_RETURN = 'UPDATE_PIPE_RETURN';
export const DELETE_PIPE_RETURN = 'DELETE_PIPE_RETURN';
export const PIPE_RETURN_REQUEST_FAILURE = 'PIPE_RETURN_REQUEST_FAILURE';
export const GET_PIPE_RETURNS_WITH_DETAIL = 'GET_PIPE_RETURNS_WITH_DETAIL';
export const PIPE_RETURN_REQUEST_SUCCESS  = 'PIPE_RETURN_REQUEST_SUCCESS';